import React from 'react';

const Footer = ({ currentPage, setCurrentPage, pages, usine, certification }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Section Logo */}
          <div className="footer-logo">
            <h3 className="footer-title">NITROKYM</h3>
            <p className="footer-text">Chimie des Chlor-Alkalis</p>
            <p className="footer-text" style={{ fontSize: '13px', marginTop: '10px' }}>
              Certification {certification?.nom || 'ISO 9001:2015'}
            </p>
            <div className="cert-badges">
              <div className="cert-badge">ISO 9001</div>
              <div className="cert-badge">QUALITÉ</div>
            </div>
          </div>

          {/* Section Produits */}
          <div>
            <h3 className="footer-title">Nos Produits</h3>
            <div className="footer-links">
              <button 
                onClick={() => setCurrentPage('produits')}
                className="footer-link"
              >
                Acide Chlorhydrique (HCl)
              </button>
              <button 
                onClick={() => setCurrentPage('produits')}
                className="footer-link"
              >
                Soude Caustique 50% (NaOH)
              </button>
              <button 
                onClick={() => setCurrentPage('produits')}
                className="footer-link"
              >
                Hypochlorite de Sodium (NaClO)
              </button>
            </div>
          </div>

          {/* Section Liens */}
          <div>
            <h3 className="footer-title">Navigation</h3>
            <div className="footer-links">
              {pages.map(page => (
                <button
                  key={page.id}
                  onClick={() => setCurrentPage(page.id)}
                  className="footer-link"
                >
                  {page.label}
                </button>
              ))}
            </div>
          </div>

          {/* Section Contact */}
          <div>
            <h3 className="footer-title">Contact</h3>
            <p className="footer-text">{usine?.adresse || 'Zone Industrielle Nord, BP 1234'}</p>
            <p className="footer-text">{usine?.ville || 'Sfax, Tunisie'}</p>
            <p className="footer-text">Tél: {usine?.telephone || '+216 71 234 567'}</p>
            <p className="footer-text">Email: {usine?.email || 'contact@nitrokym.com'}</p>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} NITROKYM. Tous droits réservés.</p>
          <p>
            <button 
              onClick={() => setCurrentPage('contact')}
              className="footer-link"
              style={{ display: 'inline', margin: '0 10px' }}
            >
              Mentions légales
            </button>
            | 
            <button 
              onClick={() => setCurrentPage('contact')}
              className="footer-link"
              style={{ display: 'inline', margin: '0 10px' }}
            >
              Politique de confidentialité
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;